import { translate } from '@manomano-internal/i18n/esm/placeholders';
export const {
  title,
  positiveSubBtnLabel,
  negativeBtnLabel
} = translate({
  "title": "Never miss our good deals, our news, our advice!",
  "positiveSubBtnLabel": "I subscribe",
  "negativeBtnLabel": "No thanks"
});